import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51620a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detailContainer" }
const _hoisted_2 = { class: "headerContainer" }
const _hoisted_3 = { class: "productSection" }
const _hoisted_4 = { class: "productSection__title" }
const _hoisted_5 = { class: "productSection__state" }
const _hoisted_6 = { class: "productSection__date" }
const _hoisted_7 = { class: "productSection__date" }
const _hoisted_8 = { class: "productSection__progressBar" }
const _hoisted_9 = { class: "productSection__state" }
const _hoisted_10 = { class: "productSection__progressBar__progressText" }
const _hoisted_11 = {
  key: 0,
  class: "productSection__buttons"
}
const _hoisted_12 = { class: "productSection" }
const _hoisted_13 = { class: "productSection__title" }
const _hoisted_14 = { class: "productSection__title" }
const _hoisted_15 = { class: "formContainer" }
const _hoisted_16 = { class: "form" }
const _hoisted_17 = { class: "form__formGroup" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre del producto", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "form__formGroup" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripción", -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "form__formGroup--date" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Fecha de Inicio", -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "form__formGroup--date" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "Fecha Fin", -1))
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "form__formGroup--row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "showState" }, "Estado", -1))
const _hoisted_31 = { class: "form__formGroup--row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "todo" }, "Por hacer", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "progress" }, "En Progreso", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "done" }, "Hecho", -1))
const _hoisted_37 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Guardar", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Eliminar Producto", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "formContainer" }
const _hoisted_48 = { class: "form" }
const _hoisted_49 = { class: "form__formGroup" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre del producto", -1))
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "form__formGroup" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripción", -1))
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "form__formGroup--date" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Fecha de Inicio", -1))
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "form__formGroup--date" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "Fecha Fin", -1))
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "form__formGroup--row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "showState" }, "Estado", -1))
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "form__formGroup--row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "todo" }, "Por hacer", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "progress" }, "En Progreso", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "done" }, "Hecho", -1))
const _hoisted_70 = [
  _hoisted_66,
  _hoisted_67,
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Crear", -1))
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_76 = [
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = { class: "stageContainer__options" }
const _hoisted_78 = { class: "headerContainer" }
const _hoisted_79 = {
  key: 0,
  class: "productSection"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "productSection__title" }, "Selecciona una etapa", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "productSection__state" }, "para ver su detalle y avance", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "productSection__date" }, null, -1))
const _hoisted_83 = [
  _hoisted_80,
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = {
  key: 1,
  class: "productSection"
}
const _hoisted_85 = { class: "productSection__title" }
const _hoisted_86 = { class: "productSection__state" }
const _hoisted_87 = { class: "productSection__date" }
const _hoisted_88 = { class: "productSection__date" }
const _hoisted_89 = { class: "productSection__progressBar" }
const _hoisted_90 = { class: "productSection__state" }
const _hoisted_91 = { class: "productSection__progressBar__progressText" }
const _hoisted_92 = {
  key: 0,
  class: "productSection__buttons"
}
const _hoisted_93 = {
  key: 2,
  class: "productSection"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "productSection__title" }, "Nueva Etapa", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "productSection__state" }, "Ingrese los datos de la nueva etapa", -1))
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "bodyContainer" }
const _hoisted_98 = { class: "productTasks" }
const _hoisted_99 = { class: "productTasks__noTasks" }
const _hoisted_100 = { class: "productTasks__newTask" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_circle ", -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = {
  key: 0,
  class: "productTasks__task--mainTask"
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "formContainer" }
const _hoisted_108 = { class: "form" }
const _hoisted_109 = { class: "form__formGroup" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre de la etapa", -1))
const _hoisted_111 = ["disabled"]
const _hoisted_112 = { class: "form__formGroup" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripción", -1))
const _hoisted_114 = ["disabled"]
const _hoisted_115 = { class: "form__formGroup--date" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Fecha de Inicio", -1))
const _hoisted_117 = ["disabled"]
const _hoisted_118 = { class: "form__formGroup--date" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "Fecha Fin", -1))
const _hoisted_120 = ["disabled"]
const _hoisted_121 = { class: "form__formGroup--row" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "showState" }, "Estado", -1))
const _hoisted_123 = { class: "form__formGroup--row" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "todo" }, "Por hacer", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "progress" }, "En Progreso", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "done" }, "Hecho", -1))
const _hoisted_129 = [
  _hoisted_125,
  _hoisted_126,
  _hoisted_127,
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Guardar", -1))
const _hoisted_132 = [
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_135 = [
  _hoisted_133,
  _hoisted_134
]
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Eliminar Etapa", -1))
const _hoisted_138 = [
  _hoisted_136,
  _hoisted_137
]
const _hoisted_139 = { class: "formContainer" }
const _hoisted_140 = { class: "form" }
const _hoisted_141 = { class: "form__formGroup" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre de la etapa", -1))
const _hoisted_143 = ["disabled"]
const _hoisted_144 = { class: "form__formGroup" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripción", -1))
const _hoisted_146 = ["disabled"]
const _hoisted_147 = { class: "form__formGroup--date" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Fecha de Inicio", -1))
const _hoisted_149 = ["disabled"]
const _hoisted_150 = { class: "form__formGroup--date" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "Fecha Fin", -1))
const _hoisted_152 = ["disabled"]
const _hoisted_153 = { class: "form__formGroup--row" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "showState" }, "Estado", -1))
const _hoisted_155 = ["disabled"]
const _hoisted_156 = { class: "form__formGroup--row" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "todo" }, "Por hacer", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "progress" }, "En Progreso", -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "done" }, "Hecho", -1))
const _hoisted_162 = [
  _hoisted_158,
  _hoisted_159,
  _hoisted_160,
  _hoisted_161
]
const _hoisted_163 = { class: "form__formGroup--row" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Orden de etapa", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige la posición", -1))
const _hoisted_166 = ["value"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Crear", -1))
const _hoisted_169 = [
  _hoisted_167,
  _hoisted_168
]
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_172 = [
  _hoisted_170,
  _hoisted_171
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_TaskItem = _resolveComponent("TaskItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.product.name), 1),
          _createElementVNode("span", _hoisted_5, "Estado: " + _toDisplayString(_ctx.formatState(_ctx.product.state)), 1),
          _createElementVNode("span", _hoisted_6, " Fecha Inicio: " + _toDisplayString(_ctx.formatUTCDate(_ctx.product.startDate)), 1),
          _createElementVNode("span", _hoisted_7, " Fecha Finalización: " + _toDisplayString(_ctx.formatUTCDate(_ctx.product.endDate)), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              style: _normalizeStyle(`width: ${_ctx.product.progress}%`)
            }, null, 4)
          ]),
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, " Progreso: " + _toDisplayString(_ctx.product.progress) + "% ", 1)
          ]),
          (_ctx.isUserAdmin || _ctx.isUserProducer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewProduct && _ctx.addNewProduct(...args))),
                  class: "productSection__buttons__button"
                }, " + Producto "),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editProjectData && _ctx.editProjectData(...args))),
                  class: "productSection__buttons__button"
                }, " Editar ")
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.editSessionOn]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("h2", _hoisted_13, "Edita Producto", 512), [
            [_vShow, !_ctx.newProductEdit]
          ]),
          _withDirectives(_createElementVNode("h2", _hoisted_14, "Nuevo Producto", 512), [
            [_vShow, _ctx.newProductEdit]
          ])
        ], 512), [
          [_vShow, _ctx.editSessionOn]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("form", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.name) = $event)),
              disabled: _ctx.disableInput,
              placeholder: "Nombre"
            }, null, 8, _hoisted_19), [
              [_vModelText, _ctx.product.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("textarea", {
              class: "projectForm__descArea",
              cols: "30",
              rows: "10",
              placeholder: "Descripción de proyecto",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.description) = $event)),
              disabled: _ctx.disableInput
            }, "\n            ", 8, _hoisted_22), [
              [_vModelText, _ctx.product.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "startDate",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.startDate) = $event)),
              disabled: _ctx.disableInput
            }, null, 8, _hoisted_25), [
              [_vModelText, _ctx.product.startDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "endDate",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.endDate) = $event)),
              disabled: _ctx.disableInput
            }, null, 8, _hoisted_28), [
              [_vModelText, _ctx.product.endDate]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatState(_ctx.product.state)), 1)
          ], 512), [
            [_vShow, !_ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createElementVNode("select", {
              id: "status",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.state) = $event)),
              placeholder: "Elige un estado"
            }, _hoisted_37, 512), [
              [_vModelSelect, _ctx.product.state]
            ])
          ], 512), [
            [_vShow, _ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "form__button form__button--saveButton",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateProduct && _ctx.updateProduct(...args)))
          }, _hoisted_40, 512), [
            [_vShow, _ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "form__button form__button--cancelButton",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
          }, _hoisted_43, 512), [
            [_vShow, _ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "form__button form__button--cancelButton",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteProduct && _ctx.deleteProduct(...args)))
          }, _hoisted_46, 512), [
            [_vShow, _ctx.editSessionOn]
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.newProductEdit]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_47, [
        _createElementVNode("form", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newProduct.name) = $event)),
              disabled: _ctx.disableInput,
              placeholder: "Nombre"
            }, null, 8, _hoisted_51), [
              [_vModelText, _ctx.newProduct.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _withDirectives(_createElementVNode("textarea", {
              class: "projectForm__descArea",
              cols: "30",
              rows: "10",
              placeholder: "Descripción de proyecto",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newProduct.description) = $event)),
              disabled: _ctx.disableInput
            }, "\n            ", 8, _hoisted_54), [
              [_vModelText, _ctx.newProduct.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "startDate",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newProduct.startDate) = $event)),
              disabled: _ctx.disableInput
            }, null, 8, _hoisted_57), [
              [_vModelText, _ctx.newProduct.startDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "endDate",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newProduct.endDate) = $event)),
              disabled: _ctx.disableInput
            }, null, 8, _hoisted_60), [
              [_vModelText, _ctx.newProduct.endDate]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "showState",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newProduct.state) = $event)),
              disabled: _ctx.disableInput
            }, null, 8, _hoisted_63), [
              [_vModelText, _ctx.newProduct.state]
            ])
          ], 512), [
            [_vShow, !_ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _withDirectives(_createElementVNode("select", {
              id: "status",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newProduct.state) = $event)),
              placeholder: "Elige un estado"
            }, _hoisted_70, 512), [
              [_vModelSelect, _ctx.newProduct.state]
            ])
          ], 512), [
            [_vShow, _ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "form__button form__button--saveButton",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveNewProduct && _ctx.saveNewProduct(...args)))
          }, _hoisted_73, 512), [
            [_vShow, _ctx.editSessionOn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "form__button form__button--cancelButton",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
          }, _hoisted_76, 512), [
            [_vShow, _ctx.editSessionOn]
          ])
        ])
      ], 512), [
        [_vShow, _ctx.newProductEdit]
      ])
    ], 512), [
      [_vShow, _ctx.context === 'product']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_77, [
        _withDirectives(_createElementVNode("span", {
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goToLastStage && _ctx.goToLastStage(...args))),
          class: "material-symbols-outlined"
        }, " vrpano ", 512), [
          [_vShow, _ctx.isLastStage]
        ])
      ]),
      _createElementVNode("div", _hoisted_78, [
        (_ctx.stageSelected === undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_83))
          : (_ctx.stageSelected !== undefined && !_ctx.newStageEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createElementVNode("h2", _hoisted_85, _toDisplayString(_ctx.stage.name), 1),
                _createElementVNode("span", _hoisted_86, "Estado: " + _toDisplayString(_ctx.formatState(_ctx.stage.state)), 1),
                _createElementVNode("span", _hoisted_87, " Fecha Inicio: " + _toDisplayString(_ctx.formatUTCDate(_ctx.stage.startDate)), 1),
                _createElementVNode("span", _hoisted_88, " Fecha Finalización: " + _toDisplayString(_ctx.formatUTCDate(_ctx.stage.endDate)), 1),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(`width: ${_ctx.stage.progress}%`)
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_90, [
                  _createElementVNode("p", _hoisted_91, "Progreso: " + _toDisplayString(_ctx.stage.progress) + "%", 1)
                ]),
                (_ctx.isUserAdmin || _ctx.isUserProducer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addTask && _ctx.addTask(...args))),
                        class: "productSection__buttons__button"
                      }, " + Tarea "),
                      _createElementVNode("button", {
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addStage && _ctx.addStage(...args))),
                        class: "productSection__buttons__button"
                      }, " + Etapa "),
                      _createElementVNode("button", {
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.editStageData && _ctx.editStageData(...args))),
                        class: "productSection__buttons__button"
                      }, " Editar ")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_96))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_97, [
        _withDirectives(_createElementVNode("div", _hoisted_98, [
          _withDirectives(_createElementVNode("div", _hoisted_99, " No hay tareas creadas para esta Etapa", 512), [
            [_vShow, _ctx.tasks.length === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_100, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Nombre de la tarea",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newTask.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newTask.name]
            ]),
            _createElementVNode("button", {
              class: "productTasks__newTask__button--add",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.createNewTask && _ctx.createNewTask(...args)))
            }, _hoisted_102),
            _createElementVNode("button", {
              class: "productTasks__newTask__button--cancel",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.cancelAddTask && _ctx.cancelAddTask(...args)))
            }, _hoisted_104)
          ], 512), [
            [_vShow, _ctx.addTaskActive]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "productTasks__task",
              key: task.id
            }, [
              (task.isPublic || _ctx.isUserAdmin || _ctx.isUserProducer || _ctx.visibleToThisUser(task.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createVNode(_component_TaskItem, {
                      task: task,
                      "is-sub-task": false,
                      "users-on-project": _ctx.usersOnProject,
                      onCreateSubtask: _ctx.createNewSubTask,
                      onTaskStateUpdated: _ctx.refreshStageData,
                      onTaskUpdated: _ctx.refreshStageData,
                      onTaskDeleted: _ctx.refreshStageData
                    }, null, 8, ["task", "users-on-project", "onCreateSubtask", "onTaskStateUpdated", "onTaskUpdated", "onTaskDeleted"]),
                    _withDirectives(_createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.manageTasksToToggle(task.id)),
                      class: "material-symbols-outlined"
                    }, " expand_more ", 8, _hoisted_106), [
                      [_vShow, task.subTasks.length > 0]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.subTasks, (subTask) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "productTasks__subTask",
                  key: subTask.id
                }, [
                  _createVNode(_component_TaskItem, {
                    task: subTask,
                    "is-sub-task": true,
                    "users-on-project": _ctx.usersOnProject,
                    onTaskStateUpdated: _ctx.refreshStageData,
                    onTaskUpdated: _ctx.refreshStageData,
                    onTaskDeleted: _ctx.refreshStageData
                  }, null, 8, ["task", "users-on-project", "onTaskStateUpdated", "onTaskUpdated", "onTaskDeleted"])
                ])), [
                  [_vShow, _ctx.shouldToggle(task.id)]
                ])
              }), 128))
            ]))
          }), 128))
        ], 512), [
          [_vShow, !_ctx.editSessionOn]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_107, [
            _createElementVNode("form", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _hoisted_110,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "name",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.stage.name) = $event)),
                  disabled: _ctx.disableInput,
                  placeholder: "Nombre"
                }, null, 8, _hoisted_111), [
                  [_vModelText, _ctx.stage.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _withDirectives(_createElementVNode("textarea", {
                  class: "projectForm__descArea",
                  cols: "30",
                  rows: "10",
                  placeholder: "Descripción de proyecto",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.stage.description) = $event)),
                  disabled: _ctx.disableInput
                }, "\n                ", 8, _hoisted_114), [
                  [_vModelText, _ctx.stage.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _hoisted_116,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "startDate",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.stage.startDate) = $event)),
                  disabled: _ctx.disableInput
                }, null, 8, _hoisted_117), [
                  [_vModelText, _ctx.stage.startDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _hoisted_119,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "endDate",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.stage.endDate) = $event)),
                  disabled: _ctx.disableInput
                }, null, 8, _hoisted_120), [
                  [_vModelText, _ctx.stage.endDate]
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_121, [
                _hoisted_122,
                _createElementVNode("span", null, _toDisplayString(_ctx.formatState(_ctx.stage.state)), 1)
              ], 512), [
                [_vShow, !_ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_123, [
                _hoisted_124,
                _withDirectives(_createElementVNode("select", {
                  id: "status",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.stage.state) = $event)),
                  placeholder: "Elige un estado"
                }, _hoisted_129, 512), [
                  [_vModelSelect, _ctx.stage.state]
                ])
              ], 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--saveButton",
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.updateStage && _ctx.updateStage(...args)))
              }, _hoisted_132, 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--cancelButton",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
              }, _hoisted_135, 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--cancelButton",
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.deleteStage && _ctx.deleteStage(...args)))
              }, _hoisted_138, 512), [
                [_vShow, _ctx.editSessionOn]
              ])
            ])
          ], 512), [
            [_vShow, !_ctx.newStageEdit]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_139, [
            _createElementVNode("form", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "name",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newStage.name) = $event)),
                  disabled: _ctx.disableInput,
                  placeholder: "Nombre"
                }, null, 8, _hoisted_143), [
                  [_vModelText, _ctx.newStage.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _withDirectives(_createElementVNode("textarea", {
                  class: "projectForm__descArea",
                  cols: "30",
                  rows: "10",
                  placeholder: "Descripción de proyecto",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newStage.description) = $event)),
                  disabled: _ctx.disableInput
                }, "\n                ", 8, _hoisted_146), [
                  [_vModelText, _ctx.newStage.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_147, [
                _hoisted_148,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "startDate",
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newStage.startDate) = $event)),
                  disabled: _ctx.disableInput
                }, null, 8, _hoisted_149), [
                  [_vModelText, _ctx.newStage.startDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_150, [
                _hoisted_151,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "endDate",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newStage.endDate) = $event)),
                  disabled: _ctx.disableInput
                }, null, 8, _hoisted_152), [
                  [_vModelText, _ctx.newStage.endDate]
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_153, [
                _hoisted_154,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "showState",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.newStage.state) = $event)),
                  disabled: _ctx.disableInput
                }, null, 8, _hoisted_155), [
                  [_vModelText, _ctx.newStage.state]
                ])
              ], 512), [
                [_vShow, !_ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_156, [
                _hoisted_157,
                _withDirectives(_createElementVNode("select", {
                  id: "status",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.newStage.state) = $event)),
                  placeholder: "Elige un estado"
                }, _hoisted_162, 512), [
                  [_vModelSelect, _ctx.newStage.state]
                ])
              ], 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_163, [
                _hoisted_164,
                _withDirectives(_createElementVNode("select", {
                  id: "status",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.newStage.order) = $event)),
                  placeholder: "Elige la posición"
                }, [
                  _hoisted_165,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePositionsArray, (position) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: 'stagePosition' + position,
                      value: position
                    }, _toDisplayString(position), 9, _hoisted_166))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newStage.order]
                ])
              ], 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--saveButton",
                onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.saveNewStage && _ctx.saveNewStage(...args)))
              }, _hoisted_169, 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--cancelButton",
                onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
              }, _hoisted_172, 512), [
                [_vShow, _ctx.editSessionOn]
              ])
            ])
          ], 512), [
            [_vShow, _ctx.newStageEdit]
          ])
        ], 512), [
          [_vShow, _ctx.editSessionOn]
        ])
      ], 512), [
        [_vShow, _ctx.stageSelected !== undefined]
      ])
    ], 512), [
      [_vShow, _ctx.context === 'stage']
    ])
  ]))
}